import { Component, Vue } from 'vue-property-decorator'
import E from 'wangeditor'
import { evaluationEmailGetEmailDetail, evaluationEmailQuerySellOrder, evaluationEmailSendEmail } from '@/api'

@Component({ name: 'apply-info' })
export default class ApplyInfo extends Vue {
  private searchIsSend = 0 // 是否已发送
  private searchApplyType = ''
  private sourceApplyTypeList = ['有', '不建议', '需学生自行与教授确认']

  private searchIsQT = true // 是否是前途
  private searchIsQTList = [
    { label: '是', value: true },
    { label: '否', value: false }
  ] // 是否是前途

  private editor: any = null

  private searchSourceName = '' // 来源名
  private searchCourseCode = '' // courseCode
  private allSellOrderNum = ''
  private currentPage = 1
  private totalPage = 1
  private editEmailFlag = false
  private templateInfo = null
  private templateName = null
  private applyInfoList: any = null
  private excludeSellOrder: any = []

  private async searchBtnClick () {
    // 筛选按钮回调，重置删除条目容器
    // 重置发送内容
    await this.getSellOrderList()
    this.templateInfo = null
    this.templateName = null
    this.excludeSellOrder = []
    if (this.editor) {
      this.editor.txt.html(this.templateInfo)
    }
  }

  private async getSellOrderList () {
    const args = {
      applyType: this.searchApplyType,
      isQianTu: this.searchIsQT,
      sourceName: this.searchSourceName,
      courseCode: this.searchCourseCode,
      limit: 20,
      currentPage: this.currentPage
    }
    const res: any = await evaluationEmailQuerySellOrder(args)
    if (!res.error && res.sellOrderList.length > 0) {
      this.$message({ type: 'success', message: '查询成功' })
    }
    const { sellOrderList, allPage, currentPage } = res
    if (sellOrderList.length === 0) {
      this.$message({ type: 'error', message: '未找到学生' })
    }

    this.applyInfoList = sellOrderList
    this.totalPage = allPage
    this.currentPage = currentPage
  }

  private async sendBtnClick () {
    if (!this.applyInfoList || this.applyInfoList.length === 0) {
      this.$message({ type: 'error', message: '未查询学生数据' })
      return
    }

    this.editEmailFlag = true
  }

  private async createEdite () {
    if (!this.editor) {
      this.editor = new E('#apply-editor')
      this.editor.config.excludeMenus = ['emoticon', 'video', 'img', 'bold', 'italic']
      this.editor.create() // 创建富文本实例
    }
    const args = {
      applyType: this.searchApplyType,
      isQianTu: this.searchIsQT
    }
    if (!this.templateInfo) {
      const res: any = await evaluationEmailGetEmailDetail(args)
      this.templateInfo = res.emailDetail
      this.templateName = res.name
    }
    this.editor.txt.html(this.templateInfo)
  }

  private async removeSomeItem (args: any) {
    for (const key in this.applyInfoList) {
      if (this.applyInfoList[key].sellOrderId === args.sellOrderId) {
        this.applyInfoList.splice(key, 1)
        this.excludeSellOrder.push(args.sellOrderId)
      }
    }
  }

  private async onPageChange () {
    await this.getSellOrderList()
  }

  private async onBtnCancel () {
    this.editEmailFlag = false
  }

  private async onBtnSend () {
    const args = {
      applyType: this.searchApplyType,
      isQianTu: this.searchIsQT,
      sourceName: this.searchSourceName,
      courseCode: this.searchCourseCode,
      excludeSellOrder: this.excludeSellOrder,
      emailDetail: this.editor.txt.html()
    }
    const res: any = await evaluationEmailSendEmail(args)
    if (!res.error) {
      this.$message({ type: 'success', message: '发送成功' })
      this.editEmailFlag = false
    }
  }
}
